const linkCls = "_61l1jln622";

export { linkCls };
import "./atom.link.style.linaria.module.css";
//# sourceMappingURL=atom.link.style.js.map
